import React, { useContext, useEffect, useState } from "react";

import {
  Grid,
  FormControlLabel,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";

import Title from "../../components/basics/Title";
import TextFieldErp from "../../components/basics/TextFieldErp";
import { formatDate } from "../../utils/formatDate";
import SelectErp from "../../components/basics/SelectErp";
import { CNDContext } from "../../context/CNDContext";
import { createCNDAgenda } from "../../repository/ERP/pub/CNDAgendaService";
import { ImutaveisContext } from "../../context/ImutaveisContext";
import Loading from "../../components/basics/Loading";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import ButtonErp from "../../components/basics/ButtonErp";
import { findCliente } from "../../repository/ERP/prouser/ClienteService";
import MaskService from "../../utils/mask/maskService";
import { validNotNull } from "../../utils/validations";
import { notify } from "../../utils/notify";
import "./CND.css";

const idTipoCNDsefazSC = "12";

const CNDCadastro = ({ nextStepper }) => {
  const [ambito, setAmbito] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [uf, setUf] = useState(null);
  const [municipio, setMunicipio] = useState(null);
  const [cnd, setCnd] = useState(null);
  const [cpfResponsavel, setCpfResponsavel] = useState("");
  const [aPartir, setAPartir] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [diasAntecedenciaProxima, setDiasAntecedenciaProxima] = useState(5);
  const [diasAntecedenciaVencer, setDiasAntecedenciaVencer] = useState(0);
  const [optionsFilterMunicipio, setOptionsFilterMunicipio] = useState([]);
  const [optionsFilterCnd, setOptionsFilterCnd] = useState([]);
  const [clientesSelecionados, setClientesSelecionados] = useState([]);
  const [showUf, setShowUf] = useState(false);
  const [showMunicipio, setShowMunicipio] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);
  const { goBack } = useHistory();

  const {
    optionsClientes: allOptionsClientes,
    loadingInputs,
    setLoadingInputs,
    setOptionsClientes: setAllOptionsClientes,
  } = useContext(CNDContext);
  const {
    optionsCND,
    optionsEstado,
    optionsMunicipio,
    loadingInputsImutaveis,
  } = useContext(ImutaveisContext);
  const [optionsClientes, setOptionsClientes] = useState([]);

  useEffect(() => {
    const getCustomers = async () => {
      try {
        setLoadingInputs((prev) => ({ ...prev, clients: true }));

        const { data } = await findCliente(queryParams.empresa_cnpj, 100000);

        if (data && Array.isArray(data)) {
          setAllOptionsClientes([
            { razao: "TODOS", id: 0, ativo: "S" },
            ...data,
          ]);
        }
      } catch (error) {
        console.error("error CNDContext getCustomers", error);
      } finally {
        setLoadingInputs((prev) => ({ ...prev, clients: false }));
      }
    };

    if (
      !allOptionsClientes ||
      !Array.isArray(allOptionsClientes) ||
      allOptionsClientes.length < 1
    ) {
      getCustomers();
    }
  }, [
    queryParams.empresa_cnpj,
    allOptionsClientes,
    setAllOptionsClientes,
    setLoadingInputs,
  ]);

  useEffect(() => {
    if (allOptionsClientes && Array.isArray(allOptionsClientes)) {
      setOptionsClientes(
        allOptionsClientes.filter(
          (item) =>
            item.ativo !== "N" &&
            (item.id === 0 || MaskService.isValid("cnpj", item.cpfcnpj || ""))
        )
      );
    }
  }, [allOptionsClientes]);

  useEffect(() => {
    setOptionsFilterMunicipio(optionsMunicipio);
  }, [optionsMunicipio]);

  useEffect(() => {
    setOptionsFilterCnd(optionsCND);
  }, [optionsCND]);

  useEffect(() => {
    setCnd(null);
    setMunicipio(null);

    setOptionsFilterMunicipio(
      uf
        ? optionsMunicipio.filter((opt) => opt.estado_codigo === uf.codibge)
        : optionsMunicipio
    );

    setOptionsFilterCnd(
      uf
        ? optionsCND.filter(
            (opt) =>
              opt.uf === uf.estado &&
              (ambito ? opt.ambito === ambito.descricao : true)
          )
        : optionsCND.filter((opt) =>
            ambito ? opt.ambito === ambito.descricao : true
          )
    );
  }, [uf, optionsMunicipio, optionsCND, ambito]);

  useEffect(() => {
    setCnd(null);
    if (!uf && !municipio) return;

    let filterClientes = [...optionsClientes];

    if (uf) {
      filterClientes = filterClientes.filter(
        (empresa) => empresa.id_estado === uf.id
      );
    }

    if (municipio) {
      filterClientes = filterClientes.filter(
        (empresa) => empresa.municipio_codigo === municipio.codigo
      );
    }

    if (filterClientes[0] && filterClientes[0].id === 0) {
      filterClientes.splice(0, 1);
    }

    setClientesSelecionados(filterClientes);
  }, [uf, municipio, optionsClientes]);

  useEffect(() => {
    if (!ambito || !uf) return;

    setOptionsFilterCnd(
      municipio
        ? optionsCND.filter(
            (opt) =>
              opt.municipio === municipio.codigo &&
              opt.uf === uf.estado &&
              opt.ambito === ambito.descricao
          )
        : optionsCND.filter(
            (opt) => opt.uf === uf.estado && opt.ambito === ambito.descricao
          )
    );
  }, [municipio, optionsCND, ambito, uf]);

  useEffect(() => {
    setCnd(null);

    if (ambito) {
      setOptionsFilterCnd(
        optionsCND.filter((optCnd) => optCnd.ambito === ambito.descricao)
      );
    }

    if (ambito && ambito.descricao === "Municipal") {
      setShowMunicipio(true);
    } else {
      setShowMunicipio(false);
      setMunicipio(null);
    }

    if (ambito && ["Estadual", "Municipal"].indexOf(ambito.descricao) !== -1) {
      setShowUf(true);
    } else {
      setShowUf(false);
      setUf(null);
    }
  }, [ambito, optionsCND]);

  const handleChangeDiasAntecedencia = (e, setValue) => {
    if (!e.target.value) return setValue(0);

    if (e.target.value < 0) {
      return setValue(0);
    }
    if (e.target.value > 99) {
      return setValue(99);
    }

    setValue(e.target.value);
  };

  const handleChangeClientesSelecionadas = (e, values) => {
    const indexTodos = values.findIndex(
      (value) => value.id === optionsClientes[0].id
    );

    if (indexTodos === values.length - 1 && values.length > 1) {
      return setClientesSelecionados([optionsClientes[0]]);
    } else if (indexTodos === 0 && values.length > 1) {
      values.splice(0, 1);
    }

    setClientesSelecionados(values);
  };

  const handleChangeCpfResponsavel = (e) => {
    setCpfResponsavel(MaskService.toMask("cpf", e.target.value));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const inputsRequireds = [
        { value: ambito, key: "ambito" },
        { value: cnd, key: "cnd" },
        { value: tipo, key: "tipo" },
      ];

      if (showUf) {
        inputsRequireds.push({ value: uf, key: "uf" });
      }

      if (showMunicipio) {
        inputsRequireds.push({ value: municipio, key: "municipio" });
      }

      if (tipo && tipo.descricao === "Automática") {
        inputsRequireds.push({ value: aPartir, key: "aPartir" });
      }

      const resultValidation = validNotNull(inputsRequireds);

      if (clientesSelecionados.length < 1) {
        resultValidation.error = true;
        resultValidation.errorsValidation.clientesSelecionados =
          "Campo obrigatório";
      }

      if (cnd && cnd.id === idTipoCNDsefazSC) {
        if (!cpfResponsavel) {
          resultValidation.error = true;
          resultValidation.errorsValidation.cpfResponsavel =
            "Campo obrigatório";
        } else if (!MaskService.isValid("cpf", cpfResponsavel)) {
          resultValidation.error = true;
          resultValidation.errorsValidation.cpfResponsavel = "CPF inválido";
        }
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return notify("Verifique se os campos estão preenchidos corretamente.");
      }

      let clientesIds = clientesSelecionados.map((empresa) => empresa.id);
      if (clientesSelecionados[0].id === 0) {
        clientesIds = [];
        optionsClientes.forEach((empresa) => {
          if (empresa.id) clientesIds.push(empresa.id);
        });
      }

      const body = {
        empresa_cnpj: queryParams.empresa_cnpj,
        cnd: cnd.id,
        ambito: ambito.descricao,
        data_inicio: tipo.descricao === "Automática" ? aPartir : null,
        tipo_consulta: tipo.descricao,
        consulta_antecedencia: diasAntecedenciaProxima,
        vencer_antecedencia: diasAntecedenciaVencer,
        empresas: clientesIds,
      };

      if (cnd && cnd.id === idTipoCNDsefazSC) {
        body.cpf_responsavel = cpfResponsavel.replace(/[^0-9]+/g, "");
      }

      const result = await createCNDAgenda(body, queryParams.empresa_cnpj);

      if (result && result.success) {
        Swal.fire({
          icon: "success",
          text: result.msg,
          showConfirmButton: true,
          timer: 5000,
        });

        if (nextStepper) nextStepper();
        else goBack();

        return;
      }

      return Swal.fire({
        icon: "error",
        text: result.msg || "Falha ao salvar registro.",
        showConfirmButton: true,
        timer: 3000,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error.msg || "Falha ao salvar registro.",
        showConfirmButton: true,
        timer: 3000,
      });

      console.error("error CNDCadastro handleSubmit", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loading open={loading} />
      <form>
        <Grid container justify="center">
          <Grid
            item
            container
            spacing={2}
            xs={11}
            style={{
              background: "white",
              borderRadius: 10,
              marginTop: 20,
              padding: 5,
            }}
          >
            <Grid item xs={12}>
              <Title titulo="Cadastro de CNDs" />
            </Grid>

            <Grid item lg={4} md={4} sm={12} xs={12}>
              <SelectErp
                helperText={errors.ambito}
                error={errors.ambito ? true : false}
                label="Âmbito"
                lg={2}
                value={ambito}
                setValue={setAmbito}
                optionsList={[
                  { descricao: "Federal" },
                  { descricao: "Estadual" },
                  { descricao: "Municipal" },
                ]}
                descriptionField="descricao"
              />
            </Grid>

            {showUf && ambito && (
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <SelectErp
                  loading={loadingInputsImutaveis.optionsEstado || false}
                  disabled={!(showUf && ambito)}
                  helperText={errors.uf}
                  error={errors.uf ? true : false}
                  label="UF"
                  lg={2}
                  value={uf}
                  setValue={setUf}
                  optionsList={optionsEstado}
                  descriptionField="nome"
                />
              </Grid>
            )}

            {showMunicipio && uf && (
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <SelectErp
                  loading={loadingInputsImutaveis.optionsMunicipio || false}
                  disabled={!(showMunicipio && uf)}
                  helperText={errors.municipio}
                  error={errors.municipio ? true : false}
                  label="Município"
                  lg={3}
                  value={municipio}
                  setValue={setMunicipio}
                  optionsList={optionsFilterMunicipio}
                  descriptionField="municipio"
                />
              </Grid>
            )}

            <Grid item lg={4} md={6} sm={12} xs={12}>
              <SelectErp
                helperText={errors.tipo}
                error={errors.tipo ? true : false}
                label="Tipo de Consulta"
                lg={2}
                value={tipo}
                setValue={setTipo}
                optionsList={[
                  { descricao: "Automática" },
                  { descricao: "Manual" },
                ]}
                descriptionField="descricao"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={12} xs={12}>
              <TextFieldErp
                disabled={!tipo || tipo.descricao !== "Automática"}
                helperText={errors.aPartir}
                error={errors.aPartir ? true : false}
                label="A partir de"
                type="date"
                value={aPartir}
                setValue={setAPartir}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item lg={4} md={12} sm={12} xs={12}>
              <SelectErp
                loading={loadingInputsImutaveis.optionsCND || false}
                helperText={errors.cnd}
                error={errors.cnd ? true : false}
                label="CND"
                lg={12}
                value={cnd}
                setValue={setCnd}
                optionsList={optionsFilterCnd}
                descriptionField="cnd"
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              alignItems="center"
              container
            >
              <FormControlLabel
                control={
                  <label className="label-modal">
                    Próximas consultas com antecedênciade
                  </label>
                }
              ></FormControlLabel>
              <TextFieldErp
                value={diasAntecedenciaProxima}
                setValue={setDiasAntecedenciaProxima}
                onChange={(e) =>
                  handleChangeDiasAntecedencia(e, setDiasAntecedenciaProxima)
                }
                className="tab-cadastro-input-days"
                type="number"
              />
              <label className="label-dias">dias</label>
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              alignItems="center"
              container
            >
              <FormControlLabel
                control={
                  <label className="label-modal">
                    Situação "A Vencer" com antecendência de
                  </label>
                }
              ></FormControlLabel>
              <TextFieldErp
                value={diasAntecedenciaVencer}
                setValue={setDiasAntecedenciaVencer}
                onChange={(e) =>
                  handleChangeDiasAntecedencia(e, setDiasAntecedenciaVencer)
                }
                className="tab-cadastro-input-days"
                type="number"
              />

              <label className="label-dias">dias</label>
            </Grid>

            {cnd && cnd.id === idTipoCNDsefazSC && (
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <TextFieldErp
                  helperText={errors.cpfResponsavel}
                  error={errors.cpfResponsavel ? true : false}
                  label="CPF do Responsável*"
                  value={cpfResponsavel}
                  setValue={setCpfResponsavel}
                  onChange={(e) => handleChangeCpfResponsavel(e)}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Autocomplete
                loading={loadingInputs.clients || false}
                multiple
                size="small"
                options={Array.isArray(optionsClientes) ? optionsClientes : []}
                getOptionLabel={(option) => option.razao}
                value={clientesSelecionados}
                onChange={handleChangeClientesSelecionadas}
                renderInput={(params) => {
                  if (optionsClientes.length === 0) {
                    params.InputProps.endAdornment = (
                      <CircularProgress color="inherit" size={20} />
                    );
                  }
                  return (
                    <TextField
                      helperText={errors.clientesSelecionados}
                      error={errors.clientesSelecionados ? true : false}
                      {...params}
                      variant="standard"
                      label="Clientes/Estabelecimentos (Com CNPJ válido)"
                    />
                  );
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              justify="flex-end"
              className="cnd-container-btns"
            >
              {!nextStepper && (
                <ButtonErp
                  cancel
                  onClick={() => {
                    sessionStorage.setItem("tabCNDPainel", 0);
                    goBack();
                  }}
                />
              )}

              <ButtonErp save onClick={handleSubmit} />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default CNDCadastro;
